import React, { useEffect } from 'react';

import { useCheckCard } from '@vlabs/api/artemy/client';
import { useCardIdFromLocationPoint3 } from '@vlabs/monokit/shared/lib/use-card-id-from-location';
import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import { Pages } from '@vlabs/uikit';

import { CardPageContent } from './card-page-content';
import st from './CardPage.module.sass';

export function CardPage(): React.ReactNode {
  const cardId = useCardIdFromLocationPoint3();
  const checkCard = useCheckCard({
    mutation: {
      retry: false,
    },
  });

  useEffect(() => {
    checkCard.mutate({ cardId });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (checkCard.isPending) return null;
  if (checkCard.isError) return <Pages.NotFoundPage />;

  return (
    <Page>
      <PageContent className={st.PageContent}>
        <CardPageContent />
      </PageContent>
    </Page>
  );
}
